import { NgoPartnerDto } from 'src/app/models/trofaco/ngoPartnerDto';
import { Injectable } from '@angular/core';
import { RequestService } from './request.service';

@Injectable({
    providedIn: 'root'
})
export class NgoPartnerService {

    constructor(private request: RequestService) {
    }

    async getNgoPartners(): Promise<NgoPartnerDto[]> {
        let result = await this.request.getApi<NgoPartnerDto[]>('plantingSites/ngo-partners');
        return result.data;
    }

    async createNgoPartner(partner: {name: string, url: string}): Promise<NgoPartnerDto> {
        console.log('creating partner');
        let result = await this.request.post('plantingSites/create-ngo-partner',
            {name: partner.name, url: partner.url});
        return result.data;
    }

    async getById(id: string): Promise<NgoPartnerDto> {
        let result = await this.request.getApi<NgoPartnerDto>('plantingSites/ngo-partner/' + id);
        return result.data;
    }

    async updateNgoPartner(data:NgoPartnerDto): Promise<NgoPartnerDto> {
        let result = await this.request.patch('plantingSites/update-ngo-partner',data);
        return result.data;
    }

    updateNgoPartnerPhoto(file: File, ngoId: string) {
        let formData = new FormData();
        formData.append('NgoPartnerPhoto', file, file.name);
        formData.append('NgoPartnerId', ngoId);
        return this.request.post('plantingSites/upload-planting-site-ngo-partner-photo', formData);
    }


}
